<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <mat-table #table id="qa-mineoplysninger-ejendomsoplysninger-mat-table" [dataSource]="vm.ejendomsoplysninger">
      <ng-container matColumnDef="navn">
        <mat-header-cell *matHeaderCellDef>Beskrivelse</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.navn }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="vaerdi">
        <mat-header-cell *matHeaderCellDef>Værdi</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.vaerdi }} {{ element.enhed }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="beskrivelse">
        <mat-header-cell *matHeaderCellDef>Tekst</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.kommentar }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="kolonneOverskifter"></mat-header-row>
      <mat-row *matRowDef="let row; columns: kolonneOverskifter"></mat-row>
    </mat-table>
  }
</dff-side>
